export const enFormPrima2 = {
    translation : {
        "Enviar documentos": "Send documents",
        "para firma": "for signature",
        "al cliente": "to the client",
        "Volver atrás": "Go back",
        "PDF Reclamación de prima única": "PDF Single Premium Claim",
        "PDF Contrato de prima única": "PDF Single Premium Contract",
        "¿Quieres modificar el contrato de prima única?": "Do you want to modify the single premium contract?",
        "Documentos que se enviarán a firma:": "Documents to be sent for signature:",
        "Reclamación de prima única": "Single Premium Claim",
        "Contrato de prima única": "Single Premium Contract",
        "Previsualizar": "Preview",
        "Ocultar previsualización": "Hide preview",
        "Previsualización Reclamación de prima única": "Single Premium Claim preview",
        "Previsualización Contrato de prima única": "Single Premium Contract preview",
        "¿Quieres modificar el algún PDF?": "Do you want to modify any PDF?",
        "Marca la casilla de abajo si deseas modificar alguno de estos documentos": "Check the box below if you want to modify any of these documents",
        "Archivo ya seleccionado": "File already selected",
        "Debes subir un archivo de reclamación de prima única": "You must upload a single premium claim file",
        "Solicitud enviada correctamente": "Request sent correctly",
        "Error al enviar la solicitud": "Error sending the request",
        "Enviar": "Send",
        "Enviando...": "Sending...",
        "En breve el cliente recibirá por email los documentos para firmar": "The client will soon receive the documents to sign by email",
        "¡Listo!": "Got it!",
    }
};